const steps = {
  where: 0,
  what: 1,
  when: 2,
  who: 3
};
const mapStepToRoute = Object.keys(steps).reduce(
  (obj, key) => ({ ...obj, [steps[key]]: key }),
  {}
);
export {
  mapStepToRoute,
  steps
};
//# sourceMappingURL=steps.js.map
